var _ellipse, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEMandate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 61.111,
    cy: 52.4446,
    rx: 38.8889,
    ry: 38.8889,
    fill: "#EA7009",
    fillOpacity: 0.12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87.889 49.6667C87.889 72.0665 68.5 90.3334 44.4445 90.3334C20.389 90.3334 1 72.0665 1 49.6667C1 27.2669 20.389 9 44.4445 9C68.5 9 87.889 27.2669 87.889 49.6667Z",
    stroke: "#EA7009",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7777 27.3997C54.274 27.3997 58.6296 28.9294 61.8444 31.9886C65.0592 34.996 66.6666 39.0664 66.6666 44.1997C66.6666 45.859 66.537 47.3368 66.2777 48.6331C65.9666 50.1886 65.6296 51.5368 65.2666 52.6775H33.7666C33.7147 53.0405 33.6888 53.559 33.6888 54.2331C33.6888 56.9294 34.4666 59.0553 36.0221 60.6109C37.6296 62.1146 39.7296 62.8664 42.3222 62.8664C44.4999 62.8664 46.3666 62.3998 47.9222 61.4664C49.5296 60.4813 50.8259 59.2109 51.8111 57.6553H63.5555C61.637 61.8035 58.6555 65.2257 54.6111 67.922C50.6185 70.5664 46.0814 71.8887 40.9999 71.8887C35.5036 71.8887 31.0962 70.3331 27.7777 67.222C24.4592 64.1109 22.7999 59.885 22.7999 54.5442C22.7999 52.9886 22.9555 51.3553 23.2666 49.6442C24.0443 45.1849 25.6258 41.2701 28.011 37.8997C30.4481 34.5294 33.4555 31.9368 37.0333 30.122C40.611 28.3071 44.5259 27.3997 48.7777 27.3997ZM55.4666 46.0664C55.5703 45.2368 55.6222 44.6405 55.6222 44.2775C55.6222 41.7886 54.8185 39.8442 53.2111 38.4442C51.6036 37.0442 49.5036 36.3442 46.911 36.3442C44.1629 36.3442 41.6999 37.2257 39.5221 38.9886C37.3444 40.6997 35.8147 43.059 34.9332 46.0664H55.4666Z",
    fill: "#EA7009"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEMandate);
export default __webpack_public_path__ + "static/media/EMandate.e0975e054176a29205d3f9da4836401f.svg";
export { ForwardRef as ReactComponent };